export const PrimaryMainColor = "#5555E7";
